export function Footer(): JSX.Element {
  return (
    <div className="Container">
      All data obtained from
      <a href="https://www.tvmaze.com/"> TVMaze.com</a>
    </div>
  );
}
